'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  exam: {
    practice: '自主练习',
    notRegister: '未报名',
    examHours: '时长',
    reRegistration: '撤回报名',
    prevPrevious: '上一题',
    accuracy: '正确率',
    reviewAudit: '审核中',
    participant: '报名',
    wrongQuestion: '错题库',
    auditNoPass: '审核未通过',
    involvement: '已参与',
    submitAnswers: '提交答案',
    continuePracticed: '继续练习',
    examination: '报名考试',
    toFavorite: '加入收藏',
    knowledgeCompetition: '知识竞赛',
    questionsAnalysis: '试题解析',
    noInvolvement: '未参与',
    answerWarning: '本次考试题目为单题不可逆，下一题之前请慎重',
    problemPoints: '题点解析',
    searchExamPractice: '搜索你感兴趣的考试和练习',
    topics: '题目',
    nextPrevious: '下一题',
    participanted: '已报名',
    startPractice: '开始练习',
    inputAnswerTips: '请输入您的答案',
    yourAnswers: '您的答案',
    rightAnswers: '正确答案',
    noAnalysis: '暂无解析',
    registration: '报名成功',
    examTime: '考试时间',
    practiced: '已练习',
    noPassingTheExam: '很遗憾您未通过本次考试',
    commitSuccess: '提交成功',
    passingTheExam: '恭喜您顺利通过本次考试'
  },
  play: {
    chapter: '章节',
    note: '笔记',
    chapterText1: '第',
    closeOrNot: '是否关闭当前窗口',
    notShowAgain: '不再提示此信息',
    gotIt: '我知道啦',
    evaluateStar: '星',
    noteBlockTitle: '笔记',
    chapterText2: '章',
    closeTips: '系统可能不会保存您所做的更改',
    tips: '温馨提示',
    autoStopTips: '由于你长时间未有操作，系统自动停止了视频播放',
    autoStop: '自动停止播放',
    noCoursePlay: '当前课程中无可播放课件',
    closeButton: '离开',
    playTips: '温馨提示：为保证您的学习时间被系统正常记录，请您点击右上角的“结束学习”按钮退出学习，如果直接关闭浏览器您的学习时间可能无法正常记录。',
    saveEvaluate: '提交',
    jump: '跳过',
    notePlaceholder: '请输入笔记',
    confirmOut: '您确定退出播放吗？',
    evaluate: '评价',
    endStudy: '结束学习',
    attention: '请注意'
  },
  questionnaire: {
    shortQuestion: '简答题',
    newLine: '新增行',
    topics: '题目',
    submitTips: '您已成功提交问卷，感谢你的参与',
    save: '保存',
    multiple: '多选题',
    description: '问卷说明',
    sort: '序号',
    handed: '交卷',
    tableQuestions: '表格题',
    printing: '打印',
    content: '内容',
    inputContent: '请输入作答内容',
    submitSuccess: '提交成功',
    single: '单选题',
    examList: '试题列表',
    deleteLine: '删除行',
    saveSuccess: '保存成功',
    notParticipat: '未参与',
    closePage: '关闭此页',
    export: '导出'
  },
  index: {
    userInfo: '个人中心',
    operateConfig: '该操作被浏览器拒绝，假如想启用该功能，请在地址栏内输入 about:config,然后将项 signed.applets.codebase_principal_support 值该为true',
    ExitSystem: '退出此系统',
    continueStudy: '继续学习',
    uploadError: '上传失败',
    homePage: '首页',
    studentRanking: '学员排行榜',
    required: '此项必填',
    faceHours: '面授学时',
    recommendCourse: '推荐课程',
    checkAllNotice: '查看全部',
    startStudy: '开始学习',
    coverImage: '封面图片',
    onlineHours: '在线学时',
    coursesRanking: '选课排行榜',
    faceCourse: '面授培训班',
    requiredCourses: '必修课',
    wecome: '欢迎您！',
    hotCourse: '最热课程',
    favoriteTips: '由于360浏览器功能限制，请按 Ctrl+D 手动收藏！',
    currentHead: '当前头像',
    telephone: '咨询电话',
    noMessage: '暂无数据',
    backToTopButton: '返回顶部',
    fullScreen: '全屏展示',
    examPractice: '考试练习',
    autoFavorite: '您的浏览器不支持,请按 Ctrl+D 手动收藏!',
    newCourse: '最新课程',
    currentUser: '当前用户',
    trainingTime: '培训时间',
    setAsHomePage: '设为首页',
    currentPhone: '当前手机',
    SystemMessage: '系统提醒',
    Help: '帮助中心',
    encryPhone: '密保手机',
    backToTop: '返回顶部',
    back: '返回',
    courseCategory: '课程分类',
    head: '头像',
    emptyMessage: '清空',
    userHead: '用户头像',
    top: '顶部',
    allCourses: '全部课程',
    checkAllMessage: '查看全部',
    course: '课程学习',
    onlineCourse: '网上专题班',
    dataDownLoad: '资源下载',
    coursehours: '学时',
    human: '人',
    notice: '通知公告',
    Administration: '管理后台',
    change: '修改',
    message: '消息',
    userName: '用户名',
    autoSetHomeTips: '您的浏览器不支持自动自动设置首页, 请使用浏览器菜单手动设置!',
    examIsOver: '的考核完成',
    impotentCourse: '重点课程',
    electiveCourses: '选修课',
    addCollection: '加入收藏夹',
    to: '至',
    accountPassword: '账户密码'
  },
  course: {
    courseYear: '年',
    examLog: '考试记录',
    noDesc: '暂无简介',
    noPublicExam: '此次试卷不公布',
    coursesCategory: '课程分类',
    checkLog: '查看记录',
    viewPaper: '查看试卷',
    newComment: '最新',
    emptyCommentTips: '评论内容不能为空',
    continueStudy: '继续学习',
    courseData: '课程资料',
    donwButton: '下载',
    relatedCourses: '相关课程',
    score: '分',
    startStudy: '开始学习',
    closeButton: '关闭',
    typeOuth: '其他',
    up: '上一页',
    courseInfo: '课程详情',
    requiredCourses: '必修课程',
    examResultPage: '考试结果页面',
    examPage: '考试页面',
    noteSource: '源自',
    item: '条',
    cancelCollect: '取消收藏',
    searchTips: '请输入课程名称',
    count: '共',
    courseExamination: '随课考试',
    studentsNum: '选课人数',
    startExam: '开始考试',
    JoinLearning: '加入学习',
    publishButton: '发布',
    uploadDate: '上传时间',
    typeDoc: '文档',
    resourceSize: '资源大小',
    hotComment: '最热',
    page: '页',
    collect: '收藏',
    items: '条/页',
    evaluate: '提交评价',
    isEvaluate: '已评价',
    cancelTips: '是否确认取消提示',
    next: '下一页',
    preview: '预览',
    no: '第',
    chapter: '章',
    reExam: '重新考试',
    className: '班级名称',
    donwNum: '下载次数',
    confirmButton: '取消按钮',
    courseEvaluate: '课程评价',
    needIETips: '当前课件需要使用IE浏览器！',
    times: '次',
    cancelButton: '取消',
    teachersDesc: '教师简介',
    allCourses: '全部课程',
    commentTips: '请输入评论内容',
    courseNote: '课程笔记',
    man: '人',
    coursehours: '学时',
    openComment: '我要评论',
    cancelConfirm: '取消收藏',
    go: '跳至',
    typeImages: '多图片',
    courseTeachers: '教师',
    typeViedo: '视频',
    courseHours: '课程学时',
    marking: '阅卷中',
    electiveCourses: '选修课程',
    deleteNoteButton: '删除',
    courseChapter: '课程章节',
    typeImage: '图片'
  },
  offlineclass: {
    evaluateTime: '评估时间',
    partySchool: '党校培训班',
    seven: '日',
    passedState: '通过状态',
    sureDelete: '你确认要删除吗',
    askLeave: '我要请假',
    three: '三',
    photos: '相册',
    sickLeave: '病假',
    phontoRequier: '照片必传',
    uploadPhoto: '相片上传',
    learningActivity: '学习活动',
    seeRecord: '查看记录',
    leaveType: '请假类型',
    inputReasonLeave: '请输入请假原因',
    beDoing: '进行时',
    classHours: '班级学时',
    five: '五',
    notEvaluation: '未评估',
    reasonLeave: '请假原因',
    inputPhotoName: '请输入相片名称',
    group: '小组',
    leaveTime: '请假时间',
    examPage: '考试页面',
    formatSupport: '支持格式支持',
    sure: '确定',
    resultPage: '考试结果页面',
    saturdays: '星期六',
    selectTime: '选择时间',
    onlineToFace: '在岗面授',
    photoCategory: '相册分类',
    is: '是',
    startLearn: '进入学习',
    firstWeek: '第1周',
    photoName: '相片名称',
    morning: '上午',
    sunday: '星期日',
    at: '于',
    photoMessage: '相片信息',
    fullTimeToFace: '脱产面授',
    phoneIsOccur: '相片名称已经存在',
    evaluating: '评估',
    longNotBits: '长度不能超过50个字符',
    hoursStandard: '学时未达标，不能参加考试',
    evalueteNotStar: '评估未开始',
    submitFailure: '交卷失败',
    examRecord: '考试记录',
    seeSubmite: '查看试卷',
    questionnaire: '调查问卷',
    tickets: '张',
    submit: '提交',
    for: '四',
    notStarted: '未开始',
    coursesTaught: '所授课程',
    notGroup: '未分组',
    evaluateEnds: '评估已结束',
    classEvaluation: '班级评估',
    searchPartySchool: '搜索你感兴趣的党校培训班',
    two: '二',
    fridays: '星期五',
    startEvaluation: '开始评估',
    isEvaluated: '已评估',
    groupTalk: '分组研讨',
    openClass: '开放班级',
    not: '否',
    teacherAbout: '教师简介',
    addPhoneTips: '新增成功,请等待审核',
    phoneNameReq: '相片名称项必填',
    deleteSuccess: '删除成功',
    inputIdea: '请输入你的想法',
    wednesday: '星期三',
    evaluationStartTime: '评估开始时间',
    passed: '通过',
    casualLeave: '事假',
    monday: '星期一',
    six: '六',
    one: '一',
    h: '时',
    selectLeaveType: '请选择请假类型',
    clear: '清空',
    thursday: '星期四',
    selctLeaveTime: '请选择请假时间',
    inputEvaluating: '请输入评估内容',
    addPhoto: '新增相片',
    afternoon: '下午',
    courseEvaluation: '教学评估',
    seeEvalute: '查看评估',
    tuesday: '星期二',
    teacherTech: '所受课程',
    searchThoseClass: '搜索你感兴趣的面授培训班',
    allClass: '全部班级',
    evening: '晚上',
    sketch: '草稿',
    evaluationInProgress: '评估进行中'
  },
  onlineclass: {
    classSchedule: '课程表',
    notBeginClass: '未开班',
    reason: '原因',
    upload: '上传',
    downloadHomework: '下载作业',
    myScore: '我的得分',
    videos: '视频',
    score: '得分',
    approved: '审核通过',
    elective: '选修',
    multiImages: '多图片',
    endClass: '已结班',
    participating: '已参加',
    hideAllMan: '收起全部学员',
    cacheSave: '暂存',
    formatSupport: '文件格式支持',
    images: '图片',
    examIsPass: '考试是否通过',
    subjectsNumber: '门数',
    startLearn: '进入班级',
    classNotStar: '班级报名尚未开始',
    classTalk: '班级讨论',
    nopassed: '尚未报名通过',
    leaveMaxBits: '请假原因最多不能超过100字',
    submitTime: '提交时间',
    trainingTime: '培训时间',
    notApproved: '未审核',
    even: '晚',
    classStudy: '班级学习',
    resourceSize: '资源大小',
    detail: '详情',
    downloadCount: '下载量',
    electiveStandard: '选修达标学时',
    clickHere: '点击这里',
    onlineClasses: '网上专题班',
    quantityOfCourses: '课程数量',
    document: '文档',
    compulsoryNumber: '必修通过数量',
    handed: '交卷',
    hot: '最热',
    inputTalkContent: '请输入讨论内容',
    groupTalk: '小组讨论',
    openReservation: '开放报名',
    noon: '午',
    clickReset: '点击按钮，撤回报名',
    notSubmit: '未提交',
    leaveNotEndTime: '请假开始时间不能等于结束时间',
    inforCertificate: '证书',
    close: '关闭',
    submitHomework: '提交作业',
    allTheClass: '全部班级',
    address: '地点',
    homework: '作业',
    subjects: '门',
    classOvered: '班级已结班',
    agentRegister: '再次报名',
    updateTime: '上传时间',
    sizeNot: '大小不能超过',
    showAllGroup: '查看全部组员',
    searchThoseClass: '搜索你感兴趣的网上专题班',
    groupMan: '组长',
    reSubmit: '重新提交',
    subjectsClass: '门课',
    to: '至',
    submited: '已提交',
    resourceType: '类型',
    registrationTime: '报名时间',
    numberOfParticipants: '报名人数',
    cancelRegister: '撤销报名',
    excellence: '优秀',
    source: '资料',
    compulsoryStandard: '必修达标学时',
    iknow: '我知道啦',
    down: '下',
    download: '下载',
    startExim: '开始考试',
    electiveNumber: '选修通过数量',
    talk: '讨论',
    up: '上',
    communication: '通讯',
    reply: '回复',
    inputReason: '请输入撤销原因',
    others: '其他',
    faceCourseClass: '面授培训班',
    hideAllGroup: '收起全部组员',
    courses: '课程',
    new: '最新',
    resource: '资源',
    cancelLike: '取消点赞',
    classIsEnd: '班级报名已结束',
    delete: '删除',
    resetRegister: '撤回报名',
    classExam: '班级考试',
    undo: '取消',
    teacher: '教师',
    showAllMan: '查看全部学员',
    noIntroduction: '暂无简介',
    notParticipat: '未参与',
    allType: '全部类型',
    uploadHomework: '上传作业',
    notice: '通知',
    comments: '评语',
    isDelete: '是否确认删除？',
    registerNow: '立即报名',
    classPassIndicator: '班级通过指标',
    compulsory: '必修',
    beginClass: '已开班',
    allClass: '全部',
    publish: '发布',
    talkTech: '讲师',
    wantTalk: '我要讨论',
    Learned: '已学习',
    category: '分类'
  },
  source: {
    classResource: '班级资源',
    searchResource: '搜索你感兴趣的资源',
    previewResource: '资源预览',
    evaluationSuccess: '评价成功',
    allResource: '全部资源',
    commonResource: '通用资源',
    className: '班级名称',
    resourceTalk: '资源评价',
    resourceEvaluation: '资源评分',
    resourceCategory: '资源分类',
    helpPoint: '帮助手册',
    isEvaluation: '您已经评价过了！',
    selectEvaluation: '您未选择评分！',
    topRelise: '置顶'
  },
  login: {
    cancel: '取消',
    resetPassword: '重置密码',
    newPhoneFomat: '新手机号格式不正确',
    continueLogin: '重新登录',
    passwordBits: '密码长度不能小于6位',
    forgetPassword: '忘记密码',
    sign: '登录',
    resetLoginTips: '您已修改密码成功，需要重新登录，3秒后自动退出',
    captchaFail: '验证码校验失败',
    newPhone: '新手机号',
    logout: '登出成功',
    changePhone: '修改手机号',
    accountNotEmpty: '账号不能为空',
    prevStep: '上一步',
    poor: '弱',
    incorrectTips: '用户名或密码输入错误',
    surePasswordEmpty: '确认密码不能为空',
    orgPhoneEmpty: '原手机号不能为空',
    inputNewPassowrd: '请输入新密码',
    rightMessageChange: '您可以在导航栏右侧的个人信息处修改',
    inputAccount: '请输入账号',
    inputPassword: '请输入密码',
    captchaNotEmpty: '验证码不能为空',
    newPhoneSupport: '新手机号不能与原手机号一致',
    phoneCaptchaEmpty: '手机验证码不能为空',
    sure: '确定',
    resetSuccessTips: '您已重置密码成功，请前往登录',
    copyRight: '版权由×××××××××所有，Copyright@2020 京ICP备案',
    phoneEmpty: '手机号不能为空',
    confimPassword: '请确认密码',
    inputOrigPassword: '请输入原密码',
    phoneNumber: '手机号',
    nextStep: '下一步',
    reset: '重置',
    surePassword: '请确认密码',
    formerPhone: '原手机号',
    clickGoHome: '点击返回登录页',
    loginNow: '立即登陆',
    strong: '强',
    confirmNot: '所填密码和确认密码不一致',
    changePasswordSuccess: '修改密码成功',
    inputUserName: '请输入用户名',
    failTips: '校验失败',
    changePhoneSuccess: '修改手机号成功',
    orgPhoneFormat: '原手机号格式不正确',
    newPhoneBinded: '新手机号已绑定',
    passwordBitsLong: '密码长度不能大于18位',
    loginFail: '登录失败，请重试!',
    bingPhone: '绑定手机号',
    accountVerif: '账号验证',
    userNameEmpty: '用户名不能为空',
    bingPhoneSuccess: '绑定手机号成功',
    onlineTraining: '辽高e学院在线培训平台',
    middle: '中',
    newPhoneEmpty: '新手机号不能为空',
    goHome: '前往首页',
    resetDone: '重置完成',
    inputCaptcha: '请输入验证码',
    phoneBinded: '手机号已绑定',
    changePhoneSuccessTips: '您已修改手机号成功',
    phoneFormat: '手机号格式不正确',
    captchaTips: '验证码输入错误',
    changePassword: '修改密码',
    phoneVerif: '手机验证',
    passwordFormat: '密码长度8到32位，包含数字和大小写字母',
    passwordNotEmpty: '密码不能为空',
    getCaptcha: '获取验证码',
    orgPhoneNot: '原手机号不正确',
    msgCaptcha: '短信验证码',
    resetSuccess: '重置成功',
    loginVertif: '登录验证'
  },
  usercenter: {
    onBusiness: '因公',
    loginAccount: '登录账号',
    practice: '练习',
    courseCollected: '课程收藏',
    chargeInfo: '收费标准',
    deleCourse: '确认是否删除该课程',
    year: '年度',
    onlineCentralizedLearning: '在线集中学习',
    otherOptionTips: '请输入需要补充的其它事项',
    onExam: '考试进行中',
    myScore: '我的得分',
    allHours: '总学时',
    phoneWrong: '请输入正确的手机号',
    confirmHandExams: '是否确认交卷',
    goBackrecommend: '返回教师推荐',
    noStartLearn: '尚未开始学习',
    score: '分',
    emptyAnswer: '选项或作答内容不能为空',
    ongoing: '进行中',
    editTeacher: '编辑',
    myQuestionnaire: '我的问卷',
    english: '英语',
    faceCourse: '课程',
    requiredCourses: '必修课程',
    cancelLeave: '撤销请假',
    wrongQuestionBank: '我的错题库',
    allTeacher: '全部教师',
    workUnit: '任职单位',
    otherInfo: '其它信息',
    passedCourse: '已通过',
    onlineSelfLearn: '自主在线学习',
    ruleString: '请输入80位(包括80)以内的字符',
    inExams: '参加考试',
    personal: '因私',
    completed: '已学完',
    confirmCancel: '确认是否撤销该请假',
    checkTeacher: '查看',
    rejectReasons: '驳回原因',
    junior: '初中生',
    passedExam: '考试已通过',
    exam: '考试',
    myCollected: '我的收藏',
    fitBusiness: '适合业务条线',
    assessmentTime: '考核时间',
    handExamsSuccess: '交卷成功',
    allCertificate: '全部证书',
    outCompanyLearnHours: '外单位学习（学时）',
    deleteCollected: '移除收藏',
    searchWrongTips: '搜索你感兴趣的错题',
    teachingStyle: '讲课风格',
    baseInfo: '基础信息',
    searchExamTips: '输入搜索的名称',
    eachQuestion: '每题',
    hasCollected: '已收藏',
    surplusMakeUpExam: '剩余补考',
    cancelTitle: '撤销确认',
    teacherNameTips: '请输入师资姓名',
    underway: '你正在进行',
    searchLeaveTips: '搜索你感兴趣的请假',
    teacherInfo: '个人信息',
    recommendTeacher: '教师推荐',
    teacherLocationTips: '请输入常驻地点',
    fitLevelTips: '请选择适合授课对象层级',
    pauseSuccess: '暂存成功',
    faceOutProduceHours: '面授脱产（学时）',
    auditDate: '申请时间',
    teachingExpertiseTips: '请输入教师授课专长',
    failedCourse: '未通过',
    yourScore: '您的得分',
    question: '题',
    teacherName: '教师姓名',
    needAudit: '待审核',
    faceTrain: '面授培训',
    welcomeMessage: '祝您开心每一天',
    addTeachers: '新增师资',
    checkInfo: '查看详情',
    assessmentStatus: '考核状态',
    learningArchives: '学习档案',
    schoolLeader: '校领导',
    myExams: '我的考试',
    auditMessage: '审批原因',
    otherOption: '其它事项',
    386: '学习档案',
    noPublicAnswers: '本次考试将不公布答案',
    examCollected: '试题',
    electiveCourses: '选修课程',
    teacherDescTips: '请输入教师简介',
    currentState: '当前状态',
    examExplain: '考试说明',
    noPublicResult: '此次试卷不公布',
    examLog: '考试记录',
    notFaceOutProduceHours: '非脱产面授（学时）',
    searchQuestionnaireTips: '输入搜索的问卷名称',
    fitLevel: '适合授课对象层级',
    newTeacher: '新增教师',
    allLeave: '全部请假',
    noticeSearchTips: '搜索你感兴趣的新闻',
    htllo: '您好',
    learningExperience: '学习履历',
    empty: '无',
    recommendUnit: '推荐单位',
    leaveState: '当前状态',
    makeUpExam: '待补考',
    contact: '联系方式',
    recommendSuccessTips: '您已成功提交推荐的教师，审核通过后该教师将加入师资库',
    startQuestionnaire: '开始答卷',
    haveTime: '剩余时间',
    searchTeacherTips: '搜索你感兴趣的教师',
    all: '全部',
    teachingExpertise: '授课专长',
    isRequired: '此项必填',
    myOnlineCourse: '我的网上专题班',
    searchTips: '输入搜索的课程名称',
    rulePhone: '请输入正确的手机号',
    noExams: '暂无考试',
    annualAssessment: '年年度考核',
    confirmDeleteTips: '是否确认删除',
    pause: '暂存',
    assessmentIndex: '考核指标',
    myLeave: '我的请假',
    deleteWrongQuestion: '移除错题库',
    autoSaveSuccess: '自动保存',
    name: '姓名',
    isOver: '已结束',
    myNotice: '我的消息',
    myOrder: '我的订单',
    notPay: '未支付',
    havePay: '已支付',
    workingIn: '任职于',
    fitBusinessTips: '请选择适合业务条线',
    onlineCenterLearnHours: '在线集中学习（学时）',
    myCourse: '我的课程',
    isCorrect: '为正解',
    checkTeacherInfo: '查看教师',
    myCertificate: '我的证书',
    onlineSelfLearnHours: '在线自主学习（学时）',
    examHours: '考试时长',
    autoSaveFailed: '自动保存失败',
    saveFailed: '保存失败',
    student: '学员',
    mathematics: '数学',
    teacherContactTips: '请输入教师联系方式',
    reExam: '重新考试',
    teacherWorkUnitTips: '请输入任职单位',
    teamLeader: '小组长',
    delete: '删除',
    allExams: '全部考试',
    times: '次',
    cancelButton: '撤销',
    ruleIsNumber: '请输入数字',
    allCourses: '全部课程',
    systemNotice: '系统提醒',
    learnTo: '学习至',
    onlineCourse: '培训项目',
    questionnaireDate: '问卷时间',
    company: '所在单位',
    searchFaceTips: '搜索你感兴趣的课程',
    teachingStyleTips: '请输入教师讲课风格',
    isCompleted: '已完成',
    outCompanyLearn: '外单位学习',
    hours: '时',
    onlineLearning: '在线学习',
    headmaster: '班主任',
    ruleNumber: '请输入8位(包括8)以内的整数',
    teachingInfo: '授课信息',
    userName: '用户名',
    message: '私信',
    confirmDelete: '删除确认',
    chargeInfoTips: '请输入收费标准',
    searchOnlineTips: '搜索你感兴趣网上专题班',
    marking: '阅卷中',
    exams: '考试',
    myFaceCourse: '我的面授培训班',
    highSchool: '高中生',
    pleaseSelect: '请选择',
    leaveInfo: '请假详情',
    location: '常驻地点',
    committeeMembers: '组织纪检委员',
    examOver: '考试已结束',
    checkQuestionnaire: '查看问卷',
    examsLog: '考试记录'
  }
};